@import '~@s-ui/theme/lib/settings-compat-v7/index';
@import '~@s-ui/theme/lib/index';

@import '~@adv-mt/mt-theme/lib/motor';

@import '~@s-ui/react-atom-button/lib/index';
@import '~@s-ui/react-atom-card/lib/index';
@import '~@s-ui/react-atom-image/lib/index';
@import '~@s-ui/react-atom-tooltip/lib/index';
@import '~@s-ui/react-atom-badge/lib/index';

@import '~@adv-mt/mt-card-alert/lib/index';
@import '~@adv-mt/mt-comparator-button/lib/index';
@import '~@adv-mt/mt-empty-case-alerts/lib/index';
@import '~@adv-mt/mt-empty-case-default/lib/index';
@import '~@adv-mt/mt-empty-case-favorites/lib/index';
@import '~@adv-mt/mt-layout-basic/lib/index';
@import '~@adv-mt/mt-list-ads/lib/index';
@import '~@adv-mt/mt-list-dealers/lib/index';
@import '~@adv-mt/mt-list-related-ads/lib/index';
@import '~@adv-mt/mt-notifications-ad-favorite/lib/index';
@import '~@adv-mt/mt-notifications-dealer-favorite/lib/index';
@import '~@adv-mt/mt-notifications-ads-comparator/lib/index';
@import '~@adv-mt/mt-notifications-alert/lib/index';
@import '~@adv-mt/mt-search-sort/lib/index';
@import '~@adv-mt/mt-title-basic/lib/index';
@import '~@adv-mt/mt-title-user-area/lib/index';

$h-user-favorites-skeleton: 536px;
$p-user-favorites-layout: 0px 8px;
$z-sticky-comparator-button: 2;

.mt-UserFavorites {
  &-content h1,
  &-recommender,
  &-skeleton,
  &-section {
    @include media-breakpoint-down(m) {
      padding: $p-user-favorites-layout;
    }
  }

  &-recommender {
    margin: $m-l 0;
    grid-column: 1 / -1;
  }

  &-content {
    display: flex;
    flex-direction: column;
    gap: $m-m;
  }

  &-header {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    margin-bottom: $m-m;
    gap: $m-m;
    height: 40px;

    @include media-breakpoint-up(m) {
      flex-direction: row;
      height: 48px;
    }
  }

  &-tabs {
    background-color: $c-gray-light-2;
    position: sticky;
    top: 0;
    width: 100%;
    z-index: 2;

    @include media-breakpoint-down(m) {
      top: $h-topbar-user-mobile;
      margin-bottom: $m-l;
    }

    .sui-MoleculeTabs-item {
      display: flex;
      flex-direction: row;
      align-items: flex-end;
      gap: $g-m;
      padding: $p-l;

      .sui-MoleculeTabs-item-icon {
        margin: 0px;
        height: 24px;
      }
    }
  }

  &-skeleton {
    width: 100%;
    height: $h-user-favorites-skeleton;
    background-color: $c-white;
    border-radius: $bdrs-l;
    box-shadow: $bxsh-m;
    margin-top: $m-xl;
  }

  &-comparatorButton {
    bottom: 0;
    position: fixed;
    z-index: $z-sticky-comparator-button;
    display: flex;
    align-items: center;
    justify-self: center;
    justify-content: center;
    width: 100%;
    padding: $p-xl;
    gap: $g-m;
  }

  &-comparatorNotification {
    &--withBottomMargin {
      top: auto;
      bottom: 0;
      // add spacing to show notification above comparator button instead of overlapping it
      margin-bottom: 64px; // comparator button height + spacing
    }
    // move notification to top when comparator is open to avoid overlap
    &--top {
      top: 0;
      bottom: auto !important; // add important to override comparator notification position
    }
  }
}
